export default {
    title: "Enquête ingediend",
    header: "@:views.survey.submitted.title",
    message: "Bedankt voor je feedback.",
}